// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"660":"8c2d81d7a0ddf0a4","837":"c0db51e7a0cdb58b","874":"6253e43770ced430","920":"6a900939674bea7d"}[chunkId] + ".js";
};